/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { patientToothChartApi } from '../api/patienttoothchart.api';
import { switchMap, map } from 'rxjs/operators';
import { PatientToothChart, PatientToothChartData, PatientToothChartHeader } from '../../../interfaces/masters/patienttoothchart';

@Injectable()
export class PatientToothChartService extends PatientToothChartData {

  constructor(private api: patientToothChartApi) {
    super();
  }

  list(url: string): Observable<PatientToothChart[]> {
    return this.api.list(url);
  }
  toothPrintList(url: string): Observable<any[]> {
    return this.api.list(url);
  }
  
  create(url: string, data: PatientToothChart[]): Observable<PatientToothChart[]> {
    return this.api.add(url,data);
  }

  createHeader(url: string, data: PatientToothChartHeader): Observable<PatientToothChartHeader> {
    return this.api.addHeader(url, data);
  }

  update(url: string, data: PatientToothChartHeader): Observable<PatientToothChartHeader> {
    return this.api.update(url,data);
  }

  updatedtl(url: string, data: PatientToothChart): Observable<PatientToothChart> {
    return this.api.updatedtl(url, data);
  }


  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
